import { QueryKey } from '@/configs/queryKeys';
import {
	ApiPaginatedResponse,
	Attachment,
	Translations,
	UUID,
} from '@/types/types';
import { ProductType } from './ProductTypeApi';
import { AttributeValue } from './AttributeValueApi';
import { Component } from './ComponentApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface ProductTypeVariantComponent extends BaseEntity {
	productTypeVariant?: ProductTypeVariant;
	productTypeVariantId: UUID;
	component: Component;
	componentId: UUID;
	optional: boolean;
	quantity: number;
}

export interface ProductTypeVariant extends BaseEntity {
	name: string;
	code: string;
	description: string;
	externalUrl: string;
	productType?: ProductType;
	productTypeId: UUID;
	attributeValues: AttributeValue[];
	attributeValuesIds: UUID[];
	price: number;
	image: Attachment | null;
	productTypeVariantComponents: ProductTypeVariantComponent[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductTypeVariantApi extends EntityApi<ProductTypeVariant> {
	constructor() {
		super(QueryKey.productTypeVariants);
		this.getAllByProductTypeId = this.getAllByProductTypeId.bind(this);
	}

	async getAllByProductTypeId(productTypeId: UUID) {
		const respone = await httpClient.get<
			ApiPaginatedResponse<ProductTypeVariant>
		>(this.queryKey, {
			params: {
				limit: -1,
				'filter.productTypeId': productTypeId,
			},
		});

		return respone.data.data;
	}
}

export default new ProductTypeVariantApi();
